export default "/images/vendor/flag-icons/flags/4x3/gf.svg?16328213544e4ac5f3ee0187f8e87292";